module.exports = __webpack_public_path__ + "img/dokter.9463b312.png";